module.exports = __webpack_public_path__ + "static/media/uoa-9.2c216a6b.jpg";